import * as actions from './actions';
import * as getters from './getters';

import { CREATE_ERROR, DELETE_ERROR, CREATE_FATAL_ERROR, DELETE_FATAL_ERROR } from './mutation-types';

// initial state
const initialState = {
    errorList: [],
    fatalError: false,
};

// mutations
const mutations = {
    [CREATE_ERROR](state, error) {
        state.errorList = error;
    },

    [DELETE_ERROR](state) {
        state.errorList = [];
    },

    [CREATE_FATAL_ERROR](state) {
        state.fatalError = true;
    },

    [DELETE_FATAL_ERROR](state) {
        state.fatalError = false;
    },
};

export default {
    state: { ...initialState },
    actions,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./resources/scripts/greenmotion-shared/vuex/errors/index.js